import * as React from "react";
import { cn } from "../../lib/utils";
import { DotIndicators } from "./DotIndicators";
const swipeThreshold = 50;
/**
 * Px of horizontal movement before the pointer is captured.
 */
const movementThreshold = 5;
export const Swipeable = ({ children, active, setActive, slides, indicator, className, }) => {
    const startX = React.useRef(null);
    const labels = React.useMemo(() => typeof slides === "number"
        ? Array.from({ length: slides }, () => "")
        : slides, [slides]);
    const total = labels.length;
    const onPointerDown = (event) => {
        if (!event.isPrimary || event.button !== 0) {
            return;
        }
        startX.current = event.clientX;
    };
    const onPointerMove = (event) => {
        if (startX.current === null) {
            return;
        }
        const element = event.currentTarget;
        if (!element.hasPointerCapture(event.pointerId) &&
            Math.abs(event.clientX - startX.current) > movementThreshold) {
            element.setPointerCapture(event.pointerId);
        }
    };
    const onPointerUp = (event) => {
        if (startX.current === null) {
            return;
        }
        const diff = event.clientX - startX.current;
        startX.current = null;
        if (diff < -swipeThreshold && active < total - 1) {
            setActive(active + 1);
        }
        else if (diff > swipeThreshold && active > 0) {
            setActive(active - 1);
        }
    };
    const onPointerCancel = () => {
        startX.current = null;
    };
    const defaultIndicator = total > 1 ? (React.createElement(DotIndicators, { labels: labels, active: active, setActive: setActive })) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn("flex-1 select-none", className), style: { touchAction: "pan-y" }, onPointerDown: onPointerDown, onPointerMove: onPointerMove, onPointerUp: onPointerUp, onPointerCancel: onPointerCancel }, children),
        indicator === undefined ? defaultIndicator : indicator));
};
//# sourceMappingURL=Swipeable.js.map